// Auto-generated by Docker build (api_url build-arg)
// Build: 20261007.6362
export const environment = {
  production: false,
  apiUrl: '/api',
  buildVersion: '20261007.6362',
  portalLinks: [],
};
